import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
class ProfileLink extends PureComponent {
    render() {
        return (_jsx("a", { href: this.props.profileUrl, title: this.props.person.fullName, children: this.props.children }));
    }
}
export default class ProfilePicture extends PureComponent {
    getProfilePhotoUrl() {
        if (this.props.photoUrl) {
            return this.props.photoUrl;
        }
        if (this.props.person && this.props.person.smallPhotoUrl) {
            return this.props.person.smallPhotoUrl;
        }
        return "";
    }
    renderProfileImage() {
        if (!this.props.showProfilePicture) {
            return "";
        }
        const profilePhotoUrl = this.getProfilePhotoUrl();
        if (profilePhotoUrl) {
            return this.renderProfilePhoto(profilePhotoUrl);
        }
        return this.renderProfileInitials();
    }
    // @ts-expect-error - TS7006 - Parameter 'profilePhotoUrl' implicitly has an 'any' type.
    renderProfilePhoto(profilePhotoUrl) {
        if (this.props.enableLink) {
            return (_jsx(ProfileLink, { person: this.props.person, profileUrl: this.props.profileUrl, children: this.renderProfileImageElement(profilePhotoUrl) }));
        }
        return this.renderProfileImageElement(profilePhotoUrl);
    }
    // @ts-expect-error - TS7006 - Parameter 'profilePhotoUrl' implicitly has an 'any' type.
    renderProfileImageElement(profilePhotoUrl) {
        return (_jsx("img", { alt: this.props.person.fullName, className: `rounded-circle ${this.props.profileImageCssClass}`, src: profilePhotoUrl }));
    }
    renderProfileInitials() {
        if (this.props.enableLink) {
            return (_jsx(ProfileLink, { person: this.props.person, profileUrl: this.props.profileUrl, children: this.renderInitialsElement() }));
        }
        return this.renderInitialsElement();
    }
    renderInitialsElement() {
        return (_jsxs("div", { className: `rounded-circle d-flex justify-content-center flex-column ${this.props.profileImageCssClass}`, style: {
                backgroundColor: this.props.person.initialsBackgroundColorHex,
            }, title: this.props.person.fullName, children: [this.props.person.firstName[0], this.props.person.lastName[0]] }));
    }
    renderRiskScoreIndicators() {
        if (!this.props.person.successScoringGroup &&
            !this.props.person.transcriptSuccessScoringGroup) {
            return "";
        }
        return (_jsxs("div", { className: "d-flex justify-content-around pt-1", children: [this.renderTermRiskScoreIndicator(), this.renderCourseRiskScoreIndicator()] }));
    }
    renderTermRiskScoreIndicator() {
        const labelText = "Term Persistence";
        if (!this.props.person.successScoringGroup &&
            this.props.person.transcriptSuccessScoringGroup) {
            return this.renderMissingRiskIndicator(labelText);
        }
        if (this.props.enableTermScore) {
            return this.renderRiskScoreIndicator(this.props.person.successScoringGroup, labelText);
        }
        return "";
    }
    renderCourseRiskScoreIndicator() {
        const labelText = "Course Completion";
        if (!this.props.person.transcriptSuccessScoringGroup &&
            this.props.person.successScoringGroup) {
            return this.renderMissingRiskIndicator(labelText);
        }
        if (this.props.enableCourseScore) {
            return this.renderRiskScoreIndicator(this.props.person.transcriptSuccessScoringGroup, labelText);
        }
        return "";
    }
    // @ts-expect-error - TS7006 - Parameter 'successScoringGroup' implicitly has an 'any' type. | TS7006 - Parameter 'labelText' implicitly has an 'any' type.
    renderRiskScoreIndicator(successScoringGroup, labelText) {
        let cssClasses = "";
        if (successScoringGroup.id === "1") {
            cssClasses = "fa fa-exclamation-circle text-danger";
        }
        else if (successScoringGroup.id === "2") {
            cssClasses = "fa fa-minus-circle text-warning";
        }
        else if (successScoringGroup.id === "3") {
            cssClasses = "fa fa-check-circle text-success";
        }
        return (_jsx("span", { className: cssClasses, title: `${labelText}: ${successScoringGroup.name}` }));
    }
    // @ts-expect-error - TS7006 - Parameter 'labelText' implicitly has an 'any' type.
    renderMissingRiskIndicator(labelText) {
        return (_jsx("span", { className: "fa fa-question-circle text-muted", title: `No ${labelText} Risk Score for this person. Contact your Aviso administrator for more details.` }));
    }
    render() {
        return (_jsxs("div", { className: "d-flex flex-column", children: [this.renderProfileImage(), this.renderRiskScoreIndicators()] }));
    }
}
// Defaults for profile picture.
// @ts-expect-error - TS2339 - Property 'defaultProps' does not exist on type 'typeof ProfilePicture'.
ProfilePicture.defaultProps = {
    profileImageCssClass: "av-profile-image",
    showProfilePicture: true,
};
